import { render, staticRenderFns } from "./ClaimsGuide.vue?vue&type=template&id=04cadb31&"
import script from "./ClaimsGuide.vue?vue&type=script&lang=js&"
export * from "./ClaimsGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports